












































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AccountService } from "@/services/account.service.ts";
import Number from "@/shared/filters/Number";
import { Account, AddAccount } from "@/models/Account.ts";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Pagination from "@/views/components/Pagination.vue";
import { KyotenData } from "@/models/KyotenData";
import { CommonService } from "@/services/Common.service";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";

export interface AccountDataTb extends Account {
  isEdit?: boolean;
  password?: string;
}

export interface ShatenData {
  shatenCd?: string;
}

export interface GroupData {
  groupCd?: string;
}

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination
  },
  mixins: [FilterSelectBox]
})
export default class CreateAccount extends Vue {
  @Prop({ default: "" })
  title: string;
  public commonService = new CommonService();
  public accountService = new AccountService();
  public accountData: AddAccount;
  public accountEdit: AddAccount;
  public accountList: AccountDataTb[] = [];
  public accountItemList: AccountDataTb[] = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;
  private loading: boolean = false;
  public kyotenDataList: KyotenData[] = [];
  public shatenDataList: ShatenData[] = [];
  public groupDataList: GroupData[] = [];
  public form: any = {
    kyotenSelected: "",
    shatenCd: "",
    groupCd: ""
  };

  public filterKyotenDataList: KyotenData[] = [];
  public filterShatenDataList: ShatenData[] = [];
  public filter: any = {
    groupCd: "",
    shatenCd: "",
    kyotenCd: ""
  };

  public dialogFormVisible: boolean = false;
  public loginType: number = 1;
  public loginTypeList: any = [];
  public allloginTypeList: any = [];
  disabledEditLoginType = true;

  constructor() {
    super();

    this.accountData = {
      userId: "",
      password: "",
      loginTypeKbn: 1
    };

    this.accountEdit = {
      userId: "",
      password: "",
      loginTypeKbn: 1
    };
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit() {
    this.loading = true;
    /** #6435 change check method. 2020-10-29 sh [START] */
    // if (
    //  this.form.kyotenSelected &&
    //  this.form.shaten &&
    //  this.form.group &&
    //  this.form.shatenCd &&
    //  this.form.groupCd &&
    //  this.accountData.userId &&
    //  this.accountData.password
    // ) {
    if (this.checkForm === false) { // disabled用なので、true,falseが逆。。。(;・∀・)
    /** #6435 change check method. 2020-10-29 sh [END] */
      this.addAccountItem({
        ...this.accountData,
        kyotenCd: this.form.kyotenSelected,
        shatenCd: this.form.shatenCd,
        groupCd: this.form.groupCd
      });
    } else {
      this.loading = false;
    }
  }

  public onFilterChanged(type: string) {
    if (type === "group") {
      this.filter.shatenCd = "";
      this.filter.kyotenCd = "";
      this.getShatenDataList(false, true).then(res => {
        this.getKyotenDataList(false, true).then(res2 => {
          this.$set(this, "accountList", []);
        });
      });
    } else if (type === "shaten") {
      this.filter.kyotenCd = "";
      this.getKyotenDataList(false, true).then(res => {
        this.$set(this, "accountList", []);
      });
    } else {
      this.getAccountList();
    }
  }

  public async getKyotenDataList(
    applyToAdd: boolean = true,
    applyToFilter: boolean = false
  ) {
    if (
      (applyToAdd && this.form.shatenCd) ||
      (applyToFilter && this.filter.shatenCd)
    ) {
      this.clearKyoten(applyToAdd, applyToFilter);
      const response = await this.accountService.getKyotens(
        applyToAdd ? this.form.groupCd : this.filter.groupCd,
        applyToAdd ? this.form.shatenCd : this.filter.shatenCd
      );
      if (response) {
        if (applyToAdd) {
          this.$set(this, "kyotenDataList", response);
        }
        if (applyToFilter) {
          this.$set(this, "filterKyotenDataList", response);
        }
      } else {
        this.clearKyoten(applyToAdd, applyToFilter);
      }
    }
  }

  clearKyoten(applyToAdd: boolean, applyToFilter: boolean) {
    if (applyToAdd) {
      this.$set(this, "kyotenDataList", []);
    }
    if (applyToFilter) {
      this.$set(this, "filterKyotenDataList", []);
    }
  }

  public async getShatenDataList(
    applyToAdd: boolean = true,
    applyToFilter: boolean = false
  ) {
    if (
      (applyToAdd && this.form.groupCd) ||
      (applyToFilter && this.filter.groupCd)
    ) {
      const response = await this.accountService.getShatens(
        applyToAdd ? this.form.groupCd : this.filter.groupCd
      );
      if (response) {
        if (applyToAdd) {
          this.$set(this, "shatenDataList", response);
        }
        if (applyToFilter) {
          this.$set(this, "filterShatenDataList", response);
        }
      } else {
        if (applyToAdd) {
          this.$set(this, "shatenDataList", []);
        }
        if (applyToFilter) {
          this.$set(this, "filterShatenDataList", []);
        }
      }
    }
  }

  public async getGroupDataList(
    applyToAdd: boolean = true,
    applyToFilter: boolean = false
  ) {
    const response = await this.accountService.getGroups();
    if (response && response.data) {
      if (applyToAdd) {
        this.$set(this, "groupDataList", response.data);
        this.form.groupCd = response.groupCd || "";
        this.form.shatenCd = response.shatenCd || "";
        this.loginType = +response.loginType;
        if (this.loginType) {
          this.accountData.loginTypeKbn = this.loginType;
        }
      }
      if (applyToFilter) {
        this.filter.groupCd = response.groupCd || "";
        this.filter.shatenCd = response.shatenCd || "";
      }
    }
  }

  public async selectGroup() {
    this.form.shatenCd = "";
    this.form.kyotenSelected = "";
    this.getShatenDataList();
  }

  public async selectShaten() {
    this.form.kyotenSelected = "";
    this.getKyotenDataList();
  }

  public async getAccountList(id?: number) {
    this.loading = true;
    const response = await this.accountService.getAccount(id, this.filter);
    this.loading = false;
    if (response) {
      const data = response.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "accountList", [...data]);
    } else {
      this.$set(this, "accountList", []);
    }
  }

  public async addAccountItem(data: any) {
    const { result, error } = await this.accountService.addAccount(data);
    if (result) {
      this.getAccountList();
      this.delay(1000);
    } else if (error) {
      this.onError(error);
      this.delay(1000);
    }
  }

  public async delAccountItem(id: number) {
    this.loading = true;
    const response = await this.accountService.deleteAccount(id);
    if (response) {
      this.getAccountList();
      this.delay(1000);
    } else {
      this.delay(1000);
    }
  }

  public async saveAccountList(data: any) {
    if (data.userId && data.password) {
      const temp = {
        id: data.id,
        userId: data.userId,
        password: data.password,
        maxLoginCnt: data.maxLoginCnt,
        dataStateKbn: data.dataStateKbn,
        loginTypeKbn: data.loginTypeKbn
      };
      const response = await this.accountService.updateAccount(temp);
      if (response) {
        this.getAccountList();
        this.delay(1000);
      } else {
        alert("システムエラーが発生しました。");
        this.delay(1000);
      }
      this.dialogFormVisible = false;
    } else {
      this.loading = false;
      alert("Please enter the password.");
    }
  }

  public clearAccountData() {
    const temp = {
      userId: "",
      password: "",
      loginTypeKbn: 1
    };
    this.$set(this, "accountData", temp);
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.accountEdit = { ...rowData };
    this.accountEdit.password = "";
    if (this.loginType <= this.accountEdit.loginTypeKbn) {
      this.disabledEditLoginType = false;
    } else {
      this.disabledEditLoginType = true;
    }
  }

  public editAccountItem() {
    this.loading = true;
    this.saveAccountList(this.accountEdit);
    // this.dialogFormVisible = false;
  }

  public restoreAccount(row: any) {
    this.loading = true;
    const temp: any = { ...row };
    temp.dataStateKbn = 1;
    // console.log('temp', temp);
    this.loading = true;
    this.restoreAccounts(temp.id); // Required password
  }

  public async restoreAccounts(id: any) {
    if (id) {
      const response = await this.accountService.restoreAccount(id);
      if (response) {
        this.getAccountList();
        this.delay(1000);
      } else {
        alert("システムエラーが発生しました。");
        this.delay(1000);
      }
    }
  }

  public tableRowClassName(row: any) {
    if (row.row.dataStateKbn === 9 && row.columnIndex !== 5) {
      return "del-user";
    }
    return "";
  }

  onError(error: any) {
    let msg = "システムエラーが発生しました。";
    if (error.data && error.data.rsltComment) {
      msg = error.data.rsltComment;
    } else if (error.statusText) {
      msg = error.statusText;
    }
    alert(msg);
  }

  private mounted() {
    this.getGroupDataList(true, true).then(res => {
      this.getLoginTypeKbn();
      this.getShatenDataList(true, true).then(res2 => {
        this.getKyotenDataList(true, true).then(res3 => {
          this.form.kyotenSelected = localStorage.getItem("kyotenCd");
          this.filter.kyotenCd = localStorage.getItem("kyotenCd");
          this.getAccountList();
        });
      });
    });
  }

  async getLoginTypeKbn() {
    const response = await this.commonService.getKbnSkns("skn_login_type_kbn");
    if (response) {
      let data = response.filter((e: any) => e.isDisabled == 0);
      data = data.sort((a: any, b: any) => (a.kbnKey > b.kbnKey ? 1 : -1));
      data = data.map((e: any) => {
        return { ...e, value2: +e.value2 };
      });
      let loginTypeList = data.filter((e: any) => +e.value2 >= this.loginType);
      this.$set(this, "loginTypeList", loginTypeList);
      this.$set(this, "allloginTypeList", data);
    }
  }

  getLoginType(kbn: number) {
    const loginType = this.allloginTypeList.find((e: any) => e.value2 == kbn);
    if (loginType) {
      return loginType.value;
    }
    return kbn;
  }

  /** #6435 change check method. 2020-10-29 sh [START] */
  get checkForm() {
    let isOK = true;

    if (!this.form.kyotenSelected) {
      isOK = false;
    }
    if (!this.form.shatenCd) {
      isOK = false;
    }
    if (!this.form.groupCd) {
      isOK = false;
    }
    if (!this.accountData.userId) {
      isOK = false;
    }
    if (!this.accountData.password) {
      isOK = false;
    }

    return !isOK;
  }
  /** #6435 change check method. 2020-10-29 sh [END] */
}
